import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { take, tap } from 'rxjs';
import { ActionModalComponent } from '../action-modal/action-modal.component';
import { CreateActionModalComponent } from './create-action-modal.component';
import { CreateActionType } from './create-action.types';
import { MODAL_TOKEN, ModalProvider } from '../../tokens';
import { AppRoutes, HostedGamesRoutes, TeamsRoutes } from '../../routes';
import { FeatureFlag, FeatureFlagHandler } from '@feature-flags';

@Injectable()
export class CreateActionModalService {
  private readonly router: Router = inject(Router);
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly featureFlagHandler: FeatureFlagHandler = inject(FeatureFlagHandler);

  open(): void {
    this.featureFlagHandler
      .isEnabled$(FeatureFlag.MULTI_TEAMS)
      .pipe(
        take(1),
        tap((isEnabled: boolean) => {
          if (isEnabled) {
            this.openModal();
          } else {
            this.router.navigateByUrl(`${AppRoutes.HOST}/${HostedGamesRoutes.CREATE_GAME}`);
          }
        })
      )
      .subscribe();
  }

  private openModal(): void {
    this.modalProvider
      .showModal$<void>({
        component: ActionModalComponent,
        cssClass: 'present-modal',
        backdropDismiss: false,
        componentProps: {
          header: 'Co chciałbyś zrobić?',
          btnOk: 'Przejdź dalej',
          btnCancel: 'Anuluj',
          template: CreateActionModalComponent,
          action: () => {
            if (CreateActionModalComponent.selectedAction === CreateActionType.TEAM) {
              this.router.navigateByUrl(`${AppRoutes.TEAMS}/${TeamsRoutes.CREATE}`);
            } else {
              this.router.navigateByUrl(`${AppRoutes.HOST}/${HostedGamesRoutes.CREATE_GAME}`);
            }
          }
        }
      })
      .pipe(take(1))
      .subscribe();
  }
}
